// src/components/Header/Header.js
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import Logo from '../../../src/assets/images/smashes-logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const closeMenu = () => setIsMenuOpen(false);
  const toggleMenu = () => setIsMenuOpen((v) => !v);

  // ✅ Cerrar con ESC
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeMenu();
    };
    if (isMenuOpen) document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isMenuOpen]);

  // ✅ Bloquear scroll cuando el menú está abierto
  useEffect(() => {
    if (isMenuOpen) document.body.classList.add('menu-open');
    else document.body.classList.remove('menu-open');

    return () => document.body.classList.remove('menu-open');
  }, [isMenuOpen]);

  // ✅ Cerrar menú al cambiar de ruta
  useEffect(() => {
    closeMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const isActive = (to) => (pathname === to ? 'active' : '');

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/" className="logo" aria-label="Ir a inicio">
          <img className="img-logo" src={Logo} alt="Logo de Smashes Store" />
        </Link>

        <button
          type="button"
          className="menu-btn"
          onClick={toggleMenu}
          aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
          aria-expanded={isMenuOpen}
          aria-controls="mobile-menu"
        >
          <span className={`menu-icon ${isMenuOpen ? 'open' : ''}`} aria-hidden="true">
            {isMenuOpen ? '✕' : '☰'}
          </span>
        </button>
      </div>

      {/* Overlay */}
      <div
        className={`menu-overlay ${isMenuOpen ? 'show' : ''}`}
        onClick={closeMenu}
        aria-hidden={!isMenuOpen}
      />

      {/* Panel */}
      <nav
        id="mobile-menu"
        className={`menu-panel ${isMenuOpen ? 'open' : ''}`}
        aria-hidden={!isMenuOpen}
      >
        <div className="menu-inner">
          <p className="menu-title">Menú</p>

          <Link className={`menu-link ${isActive('/')}`} to="/" onClick={closeMenu}>
            Inicio
          </Link>

          <Link className={`menu-link ${isActive('/products')}`} to="/products" onClick={closeMenu}>
            Perfumes
          </Link>

          <Link className={`menu-link ${isActive('/contact')}`} to="/contact" onClick={closeMenu}>
            Contacto
          </Link>

          <div className="menu-divider" />

          {/* CTA opcional (si no lo quieres, bórralo) */}
          <Link className="menu-cta" to="/products" onClick={closeMenu}>
            Explorar perfumes →
          </Link>
        </div>
      </nav>

      {/* Desktop nav (simple, arriba) */}
      <nav className="nav-desktop">
        <Link className={isActive('/')} to="/">Inicio</Link>
        <Link className={isActive('/products')} to="/products">Perfumes</Link>
        <Link className={isActive('/contact')} to="/contact">Contacto</Link>
      </nav>
    </header>
  );
};

export default Header;
